import styled, {css} from 'styled-components'

export const StyledLabel = styled.label`
    ${({theme: {palette, typography}}) => css`
        display: block;
        color: ${palette.neutral['700']};
        font-weight: 500;
        text-align: start;
        ${typography.textSm}
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    `}
`
